"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
function LicenseTagIcon(props) {
    var defaults = __assign({ viewBox: "0 0 100 100" }, props);
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, defaults),
        react_1.default.createElement("path", { fillRule: "nonzero", d: "M11.6,21.2 L2,21.2 L2,88.4 C2,93.704 6.296,98 11.6,98 L78.8,98 L78.8,88.4 L11.6,88.4 L11.6,21.2 Z" }),
        react_1.default.createElement("path", { "fill-rle": "nonzero", d: "M88.4,2 C93.704,2 98,6.296 98,11.6 L98,69.2 C98,74.504 93.704,78.8 88.4,78.8 L30.8,78.8 C25.496,78.8 21.2,74.504 21.2,69.2 L21.2,11.6 C21.2,6.296 25.496,2 30.8,2 L88.4,2 Z M82.584,39.992 L60.996,18.404 C60.132,17.54 58.932,17 57.6,17 L40.8,17 C38.148,17 36,19.148 36,21.8 L36,38.6 C36,39.932 36.54,41.132 37.416,41.996 L59.016,63.596 C59.88,64.46 61.08,65 62.4,65 C63.732,65 64.932,64.46 65.796,63.596 L82.596,46.796 C83.46,45.92 84,44.72 84,43.4 C84,42.068 83.46,40.868 82.584,39.992 Z" }),
        react_1.default.createElement("path", { fillRule: "nonzero", d: "M45.2307692,29.9230769 C43.1876923,29.9230769 41.5384615,28.2738462 41.5384615,26.2307692 C41.5384615,24.1876923 43.1876923,22.5384615 45.2307692,22.5384615 C47.2738462,22.5384615 48.9230769,24.1876923 48.9230769,26.2307692 C48.9230769,28.2738462 47.2738462,29.9230769 45.2307692,29.9230769 Z" })));
}
exports.default = LicenseTagIcon;
